"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Modal_1 = __importDefault(require("@/Jetstream/Modal"));
JetDialogModal.Content = function JetDialogModalContent(_a) {
    var title = _a.title, children = _a.children;
    return (react_1.default.createElement("div", { className: "px-6 py-4" },
        react_1.default.createElement("div", { className: "text-lg" }, title),
        react_1.default.createElement("div", { className: "mt-4" }, children)));
};
JetDialogModal.Footer = function JetDialogModalFooter(_a) {
    var children = _a.children;
    return react_1.default.createElement("div", { className: "px-6 py-4 bg-gray-100 text-right" }, children);
};
function JetDialogModal(_a) {
    var children = _a.children, modalProps = __rest(_a, ["children"]);
    return react_1.default.createElement(Modal_1.default, __assign({}, modalProps), children);
}
exports.default = JetDialogModal;
